/** Tag used in Android Logcat when WebView console is bridged in MainActivity. */
export const MOBILE_LOG_TAG = 'OneAxisApi';

function formatMessage(scope: string, message: string, detail?: unknown): string {
  const base = `[${MOBILE_LOG_TAG}] [${scope}] ${message}`;
  if (detail === undefined) {
    return base;
  }
  try {
    const serialized =
      typeof detail === 'string' ? detail : JSON.stringify(detail, sanitizeForLog, 2);
    return `${base} ${serialized}`;
  } catch {
    return `${base} ${String(detail)}`;
  }
}

function sanitizeForLog(_key: string, value: unknown): unknown {
  if (typeof value === 'string' && value.length > 512) {
    return `${value.slice(0, 512)}…`;
  }
  return value;
}

/** Logs to WebView console (forwarded to Logcat on Android via MainActivity). */
export const mobileLogger = {
  info(scope: string, message: string, detail?: unknown): void {
    console.info(formatMessage(scope, message, detail));
  },
  warn(scope: string, message: string, detail?: unknown): void {
    console.warn(formatMessage(scope, message, detail));
  },
  error(scope: string, message: string, detail?: unknown): void {
    console.error(formatMessage(scope, message, detail));
  },
};
